export const getPath = () => window.SVG_PATH || "";
export const getBrandPath = () => window.BRAND_SVG_PATH || "";
export const getProductCollectionsPath = () => window.PRODUCT_COLLECTIONS_PATH || "";
export const getCrafterpayPath = () => window.CRAFTERPAY_SVG_PATH || "";
export const getNeckLabelsPath = () => window.NECK_LABELS_SVG_PATH || "";

const useSvg = (icon, options = {}) => `
  <svg class="${options.class}" role="img">
    <use xlink:href="${getPath()}#${icon}"></use>
  </svg>
`;

export default useSvg;
